import { useEffect, useState } from "react";

/**
 * Thin golden progress bar pinned to the top of the viewport. Tracks
 * document scroll ratio. Use on long-form routes (books, wisdom, activation).
 */
export function ScrollProgress() {
  const [ratio, setRatio] = useState(0);
  useEffect(() => {
    let raf = 0;
    const compute = () => {
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const next = max > 0 ? Math.min(1, Math.max(0, doc.scrollTop / max)) : 0;
      setRatio(next);
    };
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = 0; compute(); });
    };
    compute();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", compute);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", compute);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);
  return (
    <div className="ka-progress" aria-hidden="true">
      <div className="ka-progress__bar" style={{ ["--progress" as string]: ratio }} />
    </div>
  );
}
